var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-list"},[(_vm.isAdmin)?_c('adminListing',{attrs:{"clientId":_vm.client_id}}):_c('clientListing',{attrs:{"clientId":_vm.client_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }